
import TasksModalView from "./tasks-modal.html";

angular.module("tasks")
    .factory("tasksService", ['$injector', function ($injector) {
        var instance = null;
        function remove() {
            instance = null;
        }
        var service = {
            tasks: function (entity_type, entity_type_id) {
                if (instance != null) return;
                var $uibModal = $injector.get("$uibModal");
                instance = $uibModal.open({
                    animation: true,
                    template: TasksModalView,
                    controller: 'TasksListCtrl',
                    size: 'lg',
                    resolve: {
                        entity_type: function () { return entity_type; },
                        entity_type_id: function () { return entity_type_id; }
                    }
                });
                instance.result.then(function (result) {
                    remove();
                }, function () {
                    remove();
                })
            },
            onClose: function () {
                instance.close();
            }
        };
        return service;
    }])

    .directive('tasksDirective', [function() {
        'use strict';
        return {
            restrict: 'E',
            scope: {
                to: "=",
            },           
            replace: true,
            controller: 'TasksListCtrl',
            /*link: function (scope, elem, attrs) {
                if (!attrs.entitytype) {
                    throw "Tiene que tener 'entitytype'";
                }
                logService.debug(attrs);
            },*/
            resolve: function (attrs) {
                return {
                    entitytype: function () { return attrs.entity_type; },
                    entitytypeid: function () { return attrs.entity_type_id; }
                }
            },
            template: TasksModalView,
       };
}]);
    ;